<h2 mat-dialog-title>Update Draft Info</h2>

<mat-dialog-content>

  <div class="draft-info-container">
    <mat-form-field appearance="fill">
      <mat-label>Name</mat-label>

      <input matInput [formControl]="nameForm" [placeholder]=gen_name>
    </mat-form-field>


    <mat-form-field appearance="fill">
      <mat-label>Notes</mat-label>
      <textarea matInput [formControl]="notesForm"></textarea>
    </mat-form-field>

  </div>


</mat-dialog-content>



<mat-dialog-actions>
  @if(nameForm.dirty || notesForm.dirty || nameForm.touched || notesForm.touched) {
  <button matButton="filled" color="accent" (click)="save()">Save</button>
  }
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>